import './App.css';
import Home from './pages/Home';
import Lessons from './templates/Lesson';
import Components from './lessons/MechanicalEngineering/Components';
import Design from './lessons/MechanicalEngineering/Design';
import Statics from './lessons/MechanicalEngineering/Statics';
import Profile from './pages/Profile';
import Navigation from './pages/Navigation';
import Header from './components/Header';
import Footer from './components/Footer';
import Signup from './components/Signup';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import Test from './test';
import Workbench from './pages/Workbench';
import Forum from './pages/Forum';
import { Container } from 'react-bootstrap'; 
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';



function App() {
  return (
    <AuthProvider>
        <Router>
        <Header />
            <AuthProvider>
            <Switch>
            <Route exact path='/' component={Home} />
            <Route path='/components' component={Components} />
            <Route path='/design' component={Design} />
            <Route path='/statics' component={Statics} />
            <Route path='/test' component={Test} />
            <Route path='/lessons' component={Lessons} />
            <Route path='/library' component={Navigation} />
            <Route path='/technology' component={Workbench} />
            <Route path='/tools' component={Forum} />
            <Container className="d-flex align-items-center justify-content-center" style={{minHeight: "100vh" }}>
               <div className="w-100" style={{ maxWidth: "400px" }}>
                <Route path='/signup' component={Signup} />
                <Route path='/login' component={Login} />
                <PrivateRoute path='/profile' component={Profile} />
                </div>
              </Container>
              </Switch>
            </AuthProvider>
        </Router>
      <Footer /> 
  </AuthProvider>
  );
}

export default App;
